module.exports = __webpack_public_path__ + "static/img/5.72012ee5.jpg";